/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Image_Inspector_CopiedInputs */

const en_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} copied`)
};

const ar_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تم نسخ ${i?.label}`)
};

const bn_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} কপি হয়েছে`)
};

const de_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} kopiert`)
};

const es_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se copió ${i?.label}`)
};

const fr_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} copié`)
};

const pt_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} copiado`)
};

const zh_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已复制 ${i?.label}`)
};

const tr_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} kopyalandı`)
};

const ru_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} скопировано`)
};

const pl_image_inspector_copied = /** @type {(inputs: Image_Inspector_CopiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Skopiowano ${i?.label}`)
};

/**
* | output |
* | --- |
* | "{label} copied" |
*
* @param {Image_Inspector_CopiedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_copied = /** @type {((inputs: Image_Inspector_CopiedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_CopiedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_copied(inputs)
	if (locale === "bn") return bn_image_inspector_copied(inputs)
	if (locale === "de") return de_image_inspector_copied(inputs)
	if (locale === "es") return es_image_inspector_copied(inputs)
	if (locale === "fr") return fr_image_inspector_copied(inputs)
	if (locale === "pt") return pt_image_inspector_copied(inputs)
	if (locale === "zh") return zh_image_inspector_copied(inputs)
	if (locale === "tr") return tr_image_inspector_copied(inputs)
	if (locale === "ru") return ru_image_inspector_copied(inputs)
	if (locale === "pl") return pl_image_inspector_copied(inputs)
	return en_image_inspector_copied(inputs)
});